import { render, staticRenderFns } from "./PSServiceDetail.vue?vue&type=template&id=68804198&scoped=true"
import script from "./PSServiceDetail.vue?vue&type=script&lang=js"
export * from "./PSServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./PSServiceDetail.vue?vue&type=style&index=0&id=68804198&prod&scoped=true&lang=css"
import style1 from "./PSServiceDetail.vue?vue&type=style&index=1&id=68804198&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68804198",
  null
  
)

export default component.exports